export default __webpack_public_path__ + "static/ge-3533dde5cf5158958091c7104cde01d1.svg";